module.exports = __webpack_public_path__ + "static/media/sidebar-art.f8b069fb.png";